var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container"},[_c('div',{staticClass:"box",class:{'hidden': _vm.noMargin }},[_c('div',{staticClass:"title"},[_c('span',[_vm._v(_vm._s(_vm.boxTitle))]),_vm._t("right")],2),_vm._t("info")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }